import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Bars3Icon, XMarkIcon } from '@heroicons/react/24/outline';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  const navigation = [
    { name: 'Home', href: '/', ariaLabel: 'Return to RentFi homepage' },
    { name: 'Portfolio', href: '/portfolio', ariaLabel: 'View RentFi\'s real estate portfolio and properties' },
    { name: 'Invest', href: '/invest', ariaLabel: 'Learn about investing in RENT tokens and earning passive income' },
    { name: 'FAQ', href: '/faq', ariaLabel: 'Find answers to frequently asked questions about RentFi' },
  ];

  return (
    <nav className="fixed left-0 right-0 bg-white shadow-lg z-50 top-0 h-14">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-full">
        <div className="flex justify-between items-center h-full">
          <div className="flex">
            <Link 
              to="/" 
              className="flex-shrink-0 flex items-center"
              aria-label="RentFi logo - return to homepage"
            >
              <img 
                src="https://rentfi.b-cdn.net/rentfi-iso.webp" 
                alt="RentFi Logo"
                className="h-8 w-auto"
              />
            </Link>
          </div>
          
          {/* Desktop Navigation */}
          <div className="hidden sm:flex sm:items-center">
            {navigation.map((item) => (
              <Link
                key={item.name}
                to={item.href}
                className="px-3 py-2 rounded-md text-sm font-medium text-gray-700 hover:text-primary hover:bg-gray-50"
                aria-label={item.ariaLabel}
              >
                {item.name}
              </Link>
            ))}
            <a
              href="https://raydium.io/swap/?inputMint=sol&outputMint=EPW6L3UrX8ArF4SVsGFNNNs2XccugnJGNNzXLeHUCNuz"
              target="_blank"
              rel="noopener noreferrer"
              className="ml-4 btn-cta text-sm"
              aria-label="Trade RENT tokens on Raydium decentralized exchange"
              data-tracking="cta-click"
              data-tracking-location="navbar"
              data-tracking-destination="raydium"
            >
              Trade on Raydium
            </a>
          </div>

          {/* Mobile menu button */}
          <div className="sm:hidden flex items-center">
            <button
              onClick={() => setIsOpen(!isOpen)}
              className="inline-flex items-center justify-center p-2 rounded-md text-gray-700 hover:text-primary hover:bg-gray-50"
              aria-expanded={isOpen}
              aria-label={isOpen ? "Close menu" : "Open menu"}
            >
              {isOpen ? (
                <XMarkIcon className="block h-6 w-6" />
              ) : (
                <Bars3Icon className="block h-6 w-6" />
              )}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile menu */}
      {isOpen && (
        <div className="sm:hidden absolute w-full bg-white shadow-lg">
          <div className="px-2 pt-2 pb-3 space-y-1">
            {navigation.map((item) => (
              <Link
                key={item.name}
                to={item.href}
                className="block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:text-primary hover:bg-gray-50"
                onClick={() => setIsOpen(false)}
                aria-label={item.ariaLabel}
              >
                {item.name}
              </Link>
            ))}
            <a
              href="https://raydium.io/swap/?inputMint=sol&outputMint=EPW6L3UrX8ArF4SVsGFNNNs2XccugnJGNNzXLeHUCNuz"
              target="_blank"
              rel="noopener noreferrer"
              className="block px-3 py-2 rounded-md text-base font-medium btn-cta"
              aria-label="Trade RENT tokens on Raydium decentralized exchange"
              data-tracking="cta-click"
              data-tracking-location="navbar-mobile"
              data-tracking-destination="raydium"
            >
              Trade on Raydium
            </a>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;